// Contacto público de Manklar para los enlaces que antes llevaban a la landing
// (aparcada; la web pública es manklar.com).
export const WHATSAPP_MANKLAR_URL = 'https://wa.me/34623243967';
export const WEB_MANKLAR_URL = 'https://manklar.com';
